import React, { useState, useEffect, useRef } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import ChatbotWidget from "./components/ChatbotWidget";
import ConsultationModal from "./components/ConsultationModal";
import ScrollToTop from "./components/ScrollToTop";
import HomePage from "./pages/HomePage";
import AboutPage from "./pages/AboutPage";
import ServicePageNew from "./pages/ServicePageNew";
import SeoServicesPage from "./pages/SeoServicesPage";
import SocialMediaMarketingPage from "./pages/SocialMediaMarketingPage";
import PpcServicesPage from "./pages/PpcServicesPage";
import WebDesignPage from "./pages/WebDesignPage";
import EcommerceServicesPage from "./pages/EcommerceServicesPage";
import ContentMarketingPage from "./pages/ContentMarketingPage";
import EmailMarketingPage from "./pages/EmailMarketingPage";
import ContactPage from "./pages/ContactPage";
import BlogPage from "./pages/BlogPage";
import BlogDetailPage from "./pages/BlogDetailPage";

function App() {
  const [popupOpen, setPopupOpen] = useState(false);
  const isAutoPopupRef = useRef(false);
  const autoOpenTimerRef = useRef(null);
  const autoCloseTimerRef = useRef(null);
  
  const helmetContext = {};

  useEffect(() => {
    // Auto-popup on first load (then auto-close after 2 seconds)
    autoOpenTimerRef.current = setTimeout(() => {
      isAutoPopupRef.current = true;
      setPopupOpen(true);

      autoCloseTimerRef.current = setTimeout(() => {
        if (isAutoPopupRef.current) setPopupOpen(false);
      }, 2000);
    }, 0);

    // Listen for manual triggers from any button site-wide
    const handler = () => {
      // If user manually opens the modal, do not auto-close it.
      isAutoPopupRef.current = false;
      if (autoCloseTimerRef.current) clearTimeout(autoCloseTimerRef.current);
      autoCloseTimerRef.current = null;
      setPopupOpen(true);
    };
    window.addEventListener("open-consultation-modal", handler);
    return () => {
      if (autoOpenTimerRef.current) clearTimeout(autoOpenTimerRef.current);
      if (autoCloseTimerRef.current) clearTimeout(autoCloseTimerRef.current);
      isAutoPopupRef.current = false;
      window.removeEventListener("open-consultation-modal", handler);
    };
  }, []);

  return (
    <HelmetProvider context={helmetContext}>
      <ScrollToTop />
      <Navbar />
      <Routes>
        <Route path="/" element={<HomePage />} />
        
        {/* Core Pages */}
        <Route path="/about" element={<AboutPage />} />
        <Route path="/about-us" element={<Navigate to="/about" replace />} />
        
        <Route path="/services" element={<ServicePageNew />} />
        <Route path="/digital-marketing-services" element={<Navigate to="/services" replace />} />
        
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/contact-us" element={<Navigate to="/contact" replace />} />
        
        {/* SEO Optmized Pages */}
        <Route path="/seo-services-delhi-ncr" element={<SeoServicesPage />} />
        <Route path="/seo-services" element={<Navigate to="/seo-services-delhi-ncr" replace />} />
        
        <Route path="/social-media-marketing-delhi-ncr" element={<SocialMediaMarketingPage />} />
        <Route path="/social-media-marketing-services" element={<Navigate to="/social-media-marketing-delhi-ncr" replace />} />
        
        <Route path="/ppc-services-delhi-ncr" element={<PpcServicesPage />} />
        <Route path="/ppc-management-services" element={<Navigate to="/ppc-services-delhi-ncr" replace />} />
        
        <Route path="/website-design-development-delhi-ncr" element={<WebDesignPage />} />
        <Route path="/website-design-development-services" element={<Navigate to="/website-design-development-delhi-ncr" replace />} />
        
        <Route path="/ecommerce-services-delhi-ncr" element={<EcommerceServicesPage />} />
        <Route path="/ecommerce-marketing-services" element={<Navigate to="/ecommerce-services-delhi-ncr" replace />} />
        
        <Route path="/content-marketing-services-delhi-ncr" element={<ContentMarketingPage />} />
        <Route path="/content-marketing-services" element={<Navigate to="/content-marketing-services-delhi-ncr" replace />} />
        
        <Route path="/email-marketing-services-delhi-ncr" element={<EmailMarketingPage />} />
        <Route path="/email-marketing-services" element={<Navigate to="/email-marketing-services-delhi-ncr" replace />} />
        
        <Route path="/blog" element={<BlogPage />} />
        <Route path="/blog/:slug" element={<BlogDetailPage />} />
      </Routes>
      <Footer />
      <ChatbotWidget />

      {/* Auto-popup consultation form on page load */}
      <ConsultationModal isOpen={popupOpen} onClose={() => setPopupOpen(false)} />
    </HelmetProvider>
  );
}

export default App;
